// Start up Flux with the store states
import Flux from 'lib/flux';

const storeStateScript = document.getElementById('stores_state');
if (storeStateScript) {
  Flux.start(JSON.parse(storeStateScript.text.trim()));
} else {
  Flux.start();
}
